module.exports = __webpack_public_path__ + "static/banner-footer-update-data-ar-0585051841419d986b38ba902e42e486.png";